import { Controller } from "react-hook-form";
import { toast } from "react-toastify";
import { useEffect } from "react";

// utilities
import { classNames } from "../../utilities";


export const FormTextInput = (props) => {
  
  // input
  const {
    containerclassstyle = '',
    label,
    description = null,
    form,
    name,
    rules = {},
    editable = true
  } = props;

  // watch for errors
  const { formState: { errors } } = form;

  useEffect(() => {
    console.log('FormTextInput', 'errors', errors);
    // sanity check
    if (!errors.hasOwnProperty(name)) return;

    toast.error(errors[name].message);
    form.clearErrors(name)
  }, [errors, name])

  return (
    <Controller
      name={name}
      control={form.control}
      rules={rules}
      render={({ field: { onChange, onBlur, value } }) => (
        <div className={containerclassstyle}>
          {label && <h3 className='text-lg text-slate-500 font-bold'>{label}</h3>}
          {description && <p className='text-sm text-slate-500 font-light'>{description}</p>}
          <input
            className={classNames(
              'px-4 border border-slate-300 rounded-lg text-base text-slate-700 shadow-sm placeholder:font-light placeholder:text-slate-400',
              !editable && 'bg-slate-100'
            )}
            value={value}
            onChange={onChange}
            {...props}
          />
        </div>
      )}
    />
  )
}